module.exports = __webpack_public_path__ + "img/mouth2.f35fc4bd.svg";